<template>
   <div class="teacher_cx">

     <p class="sjs"><a v-bind:href="teacherurl"><img src="http://www.xdf.cn/zhuanti/school/wapm8.27/m1/img/sjs.png" alt=""/><span class="sjs_1">搜教师</span></a></p>
     <p class="sjs a"><a v-bind:href="mapurl"><img src="http://www.xdf.cn/zhuanti/school/wapm8.27/m1/img/dt.png" alt=""/><span class="sjs_1">地图</span></a></p>

   </div>

</template>
<script>
  export default{
    props: ['teacherurl','mapurl'],
    data: function () {
      return {

      }
    },
    methods: {},
    mounted(){

    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// components/SearchTeachersMap.vue